import React, { useEffect, useState } from "react";

import { getHaInConversionPrediction } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, MainPage } from "components";

export const PredictedHaInConversion = () => {
  const signal = useCancelAsyncOnUnmount()();

  const [loading, setLoading] = useState(true);
  const [haInConversionPredictions, setHaInConversionPredictions] = useState(true);

  const loadHaInConversionPrediction = () => {
    getHaInConversionPrediction({
      signal,
    }).then((res) => {
      if (res && res.length > 0) {
        setHaInConversionPredictions(res);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    loadHaInConversionPrediction();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Predicted Ha In Conversion"
        description="This page displays the growth rate for Ha In Conversion for the current year and the following four years (last quarter of each year). We calculate the growth rate using Ha In Conversions of the past three quarters and apply it to the upcoming years. These values update automatically on the first day of every month."
        extra={
          <Button size="small" type="secondary" href="/partners/predictions/forecasts">
            Credit forecasts
          </Button>
        }
      />
      <AdminTable dataSource={haInConversionPredictions} config={{}} />
    </MainPage>
  );
};
